// src/components/report_details/UrlDataSection.tsx
import React from 'react';
import Directories from './Directories/Directories';
import Waf from './WAF/Waf';
import Technologies from './Technologies/Technologies';
import { TechnologyDetail, UrlDetails } from '../../types/interfaces';

export interface URLData {
  id: number;
  url: string;
}

interface UrlDataSectionProps {
  selectedUrl: string | null;
  urls: URLData[];
  onUrlChange: (url: string) => void;
  urlDetails: { [key: string]: UrlDetails };
}

const UrlDataSection: React.FC<UrlDataSectionProps> = ({
  selectedUrl,
  urls,
  onUrlChange,
  urlDetails,
}) => {
  // Si hay una URL seleccionada y existe información, la usamos; si no, usamos valores por defecto.
  const currentUrlDetails: UrlDetails =
    selectedUrl && urlDetails[selectedUrl]
      ? urlDetails[selectedUrl]
      : { waf: undefined, technologies: [], directories: [] };

  // Agrupar tecnologías por categoría:
  const groupedTechnologies = currentUrlDetails.technologies.reduce(
    (acc, tech) => {
      const category = tech.categoryName || 'Sin categoría';
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(tech);
      return acc;
    },
    {} as { [category: string]: TechnologyDetail[] }
  );

  return (
    <div className="mt-6">
      <Directories
        selectedUrl={selectedUrl}
        urls={urls}
        onUrlChange={onUrlChange}
        directoriesData={currentUrlDetails.directories}
      />
      <Waf
        selectedUrl={selectedUrl}
        urls={urls}
        onUrlChange={onUrlChange}
        wafData={currentUrlDetails.waf || null}
      />
      <Technologies
        selectedUrl={selectedUrl}
        urls={urls}
        onUrlChange={onUrlChange}
        technologiesData={groupedTechnologies}
      />
    </div>
  );
};

export default UrlDataSection;
